import React, {useState, useEffect, useRef} from 'react';

import {
    Button, List, ListItem, ListItemText,
    Paper,
    Typography
} from "@material-ui/core";
import {Alert} from "@material-ui/lab";
import useStyles from "../styles/styles";
import {useMutation} from "@apollo/react-hooks";
import {gql} from "apollo-boost";
import SignatureBlockPairModal from "../components/SignatureBlock/SignatureBlockPairModal";
import OptOutListModal from "../components/OptOuts/OptOutListModal";
import theme from "../styles/theme";

const OptOuts = () => {
    const classes = useStyles();
    const [success, setSuccess] = useState(false);
    const [optOutResults, setOptOutResults] = useState([])
    const [modalData, setModalData] = useState({
        open: false,
        value: [],
        type: ""
    });
    const [finalValue, setFinalValue] = useState('');
    const closeModal = () => {
        setModalData({
            open: false,
            value: []
        });
    };

    /**
     * Create Single Value SignatureBlock Graphql
     */
    const [optOutAddresses, {loading: optOutAddressesLoading, error: optOutAddressesError}] = useMutation(gql`
        
        mutation OptOutAddresses(
            $addresses: [String!]!
            $channelType: ChannelType!
        ) {
            optOutAddressesFromAdmin(
                addresses: $addresses,
                channelType: $channelType
            ) {
                address,
                companyId,
                message,
                success,
                channelType
            }
        }
    `);

    useEffect(() => {
        if (!optOutAddressesLoading) {
            closeModal();
            setFinalValue('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [optOutAddressesLoading]);

    function getAlertSeverity(result) {
        switch (result.message) {
            case 'This email has been opted out':
                return "success"
            case 'This phone has been opted out':
                return "success"
            case 'This email has already been opted out':
                return "warning"
            case 'This phone has already been opted out':
                return "warning"
            default:
                return 'error'
        }
    }

    /**
     * Main Return for Component
     */
    return (
        <>
            <Typography variant="h2">
                Opt Outs
            </Typography>
            {(optOutAddressesError) ? (
                <Paper className={classes.paper}>
                    <Alert severity="error">There is an error!</Alert>
                    <pre>{JSON.stringify( optOutAddressesError, null, 2)}</pre>
                </Paper>
            ) : null}
            {modalData.open ? <OptOutListModal
                modalData={modalData}
                closeModal={closeModal}
                optOutAddresses={optOutAddresses}
                type={modalData.type}
                setOptOutResults={setOptOutResults}
            /> :  (
                <>
                    <div className={classes.optOuts}>
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={false}
                            onClick={() => {
                                setModalData({...modalData, open: true, type: "EMAIL"});
                            }}>
                            Opt Out Emails
                        </Button>

                        <Button
                            style={{marginTop: theme.spacing(1)}}
                            variant="contained"
                            color="primary"
                            disabled={false}
                            onClick={() => {
                                setModalData({...modalData, open: true, type: "SMS"});
                            }}>
                            Opt Out Sms
                        </Button>
                    </div>

                {optOutResults ?
                        optOutResults.map((result) => {
                            let severity = getAlertSeverity(result);
                            return (
                                <Alert severity={severity}>
                                    {result.email}: {result.message}
                                </Alert>
                            );
                        })
                    : null}
                </>
            )}

        </>
    );
};

export default OptOuts;
